import TypesOfAccidentsSummary from './TypesOfAccidentsSummary';

export default TypesOfAccidentsSummary;
